// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const ClaimsStatus = t.struct({
    allowedStatuses: t.Array,
    selectedStatuses: t.Array
}, {
    name: 'ClaimsStatus',
    strict: true
});

export const getDefaultState = () => new ClaimsStatus({
    allowedStatuses: [],
    selectedStatuses: []
});

export default ClaimsStatus;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claims-status.js